import(/* webpackMode: "eager" */ "/home/runner/work/github-workflows/github-workflows/react-ui-clone/src/app/(nyshex_login)/page.tsx");
